import { usePrincipal } from '../application/authentication'
import { useProduct } from '../application/product/productContext'
import { useProposal } from '../application/product/proposal/ProposalProvider'
import { withApiErrorHandling } from '../clients/api'
import { CustomerCheckResults, getCurrentQuote, isCheckoutSkippable } from '../domain'
import { isCheckEnabled } from '../state/configuration'
import { useErrorHandlingAsyncCallback } from './errors'
import { useQuotePremiums } from './premiums'

export const useCheckoutBind = (
  onSuccess: () => void,
  onUnverified: (checks: CustomerCheckResults) => void,
  onOutstandingBalance: () => void,
) => {
  const { apiClient } = usePrincipal()
  const { product } = useProduct()
  const { dispatch, proposal } = useProposal()

  const quote = getCurrentQuote(proposal)
  const premiums = useQuotePremiums(quote, product)

  return useErrorHandlingAsyncCallback(async () => {
    const customerVerified = isCheckEnabled(product, 'verify')
      ? await apiClient.verifyCustomer(proposal.proposalCode)
      : { isClear: true, checks: {} }

    customerVerified.isClear
      ? await withApiErrorHandling(
          async () => {
            const customerAccount = await apiClient.createCustomerAccount(
              proposal.proposalCode,
            )

            if (isCheckoutSkippable(customerAccount, premiums)) {
              dispatch({
                type: 'UPDATE_PROPOSAL',
                payload: await apiClient.bindProposal(proposal.proposalCode),
              })
            }

            onSuccess()
          },
          onOutstandingBalance,
          [402],
        )
      : onUnverified(customerVerified.checks)
  })
}
